require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-microsoft-engineers-mentor-code-fellows-alumni-during-philanthropic-hackathon.json") })
        }
      }, "path---blog-microsoft-engineers-mentor-code-fellows-alumni-during-philanthropic-hackathon");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-microsoft-engineers-mentor-code-fellows-alumni-during-philanthropic-hackathon!./.cache/json/blog-microsoft-engineers-mentor-code-fellows-alumni-during-philanthropic-hackathon.json
// module id = 980
// module chunks = 231608221292675